module.exports = __webpack_public_path__ + "static/25-littlesimz-f23824beb725660858c00463d50d3265.jpg";